import { NavigationState, PartialState } from "@react-navigation/native";
import * as Network from "expo-network";

import { logError } from "~/utils/logger";

export const getIpAddress = async () => {
  try {
    const ip = await Network.getIpAddressAsync();
    return ip;
  } catch (error) {
    logError(error);
  }
};

export const getNestedRoute = (navState: any, deepLevel: number) => {
  let current: NavigationState | PartialState<NavigationState> = navState;

  if (deepLevel < 0) {
    return;
  }

  if (deepLevel === 0) {
    if (
      current &&
      "routes" in current &&
      current.routes &&
      current.routes.length > 0
    ) {
      return current.routes[0];
    }
    return;
  }

  for (let i = 0; i < deepLevel; i++) {
    if (!current || !current.routes || current.routes.length === 0) {
      return;
    }

    const nextRoute = current.routes[0];

    if (i === deepLevel - 1) {
      return nextRoute;
    }

    if (!nextRoute.state) {
      return;
    }

    current = nextRoute.state;
  }

  return;
};
